<!--  -->
<template>
    <div>
        <div class="guide-block"></div>
        <van-cell-group>
            <van-cell center title="常见问题">
                <template #title>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/question.png" alt="" />
                        <p>常见问题</p>
                    </div>
                </template>
            </van-cell>
            <van-cell v-for="item in questionList" :key="item.id" @click="skipDetail(item)" is-link>
                <template #title>
                    <div class="guide-item flex align-center">
                        <div></div>
                        <p>{{ item.title }}</p>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
    </div>
</template>

<script>
export default {
    name: "Question",
    data() {
        return {
            questionList: [
                {
                    id: 0,
                    title: "如何进行订单申诉？",
                    content: `
                    <p>
                   如需进行订单申诉，可点击【客服帮助】，页面上方点击【订单申诉】，选择对应的订单进行申诉，填写申诉原因并进行提交，工作人员会在三个工作日内处理您的问题。
                    </p>`,
                },
            ],
        };
    },

    components: {},

    computed: {},

    mounted() {},

    methods: {
        //跳转到指南详情
        skipDetail(item) {
            this.$router.push({
                name: "operationGuideDetail",
                params: item,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.guide-block {
    height: 16px;
}
.guide-item {
    div {
        width: 32px;
        height: 32px;
    }

    img {
        width: 32px;
        height: 32px;
    }
    p {
        font-size: 28px;
        color: #333333;
        margin-left: 17px;
    }
}
</style>
